const validateSsn = (id: string): boolean => {
  //  ^[0-9]{2}: The first two characters are digits.
  // (0[1-9]|[12][0-9]|3[01]): The following two characters form a valid day (01-31).
  // (0[1-9]|1[0-2]): The next two characters form a valid month (01-12).
  // \d{2}: The next two characters are any digits (representing a year).
  // [A-Z]: The next character is an uppercase letter.
  // \d{3}$: The final three characters are digits.
  const SSN_REGEX = /^[0-9]{2}(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{2}[a-zA-Z]\d{3}$/

  if (!id || id.length === 0) {
    return false
  }
  return SSN_REGEX.test(id)
}

export default validateSsn
